/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileContentModuleRegular_browseContentModule = {
    readonly description: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedStorefrontLink_browseContentModule">;
    readonly " $refType": "SbMobileContentModuleRegular_browseContentModule";
};
export type SbMobileContentModuleRegular_browseContentModule$data = SbMobileContentModuleRegular_browseContentModule;
export type SbMobileContentModuleRegular_browseContentModule$key = {
    readonly " $data"?: SbMobileContentModuleRegular_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileContentModuleRegular_browseContentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileContentModuleRegular_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedStorefrontLink_browseContentModule"
    }
  ],
  "type": "ContentModuleRegular",
  "abstractKey": null
};
(node as any).hash = '8940ed035017cc7eb437fe2d119e3e32';
export default node;
